var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.$attrs.landingPage)?_c('landing-wrapper',[_c('terms-of-service-content')],1):_c('terms-of-service-content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }